<template>
    <div class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3">
        <p class="text-gray-700 mb-4">{{ label }}</p>

        <div
            :key="`${index}-${currencyAmount}`"
            v-for="(currencyAmount, index) in value"
            class="relative mt-2 max-w-4xl"
        >
            <div class="flex">
                <div class="w-60">
                    <label class="block mb-1">Currency:</label>
                    <reference-select
                        model-data="Currency"
                        :language="language"
                        v-model="currencyAmount.currency_id"
                        :order="{
                            name: 'asc',
                        }"
                    />
                </div>

                <input-text
                    label="Amount:"
                    name="amount"
                    class="ml-4 w-24"
                    :disabled="!!currencyAmount.without_limits"
                    v-model="currencyAmount.amount"
                />

                <input-checkbox
                    v-if="withoutLimits"
                    name="without_limits"
                    label="Without Limits"
                    class="ml-4 pt-7"
                    v-model="currencyAmount.without_limits"
                    @change="withoutLimitsChanged(currencyAmount)"
                />

                <div @click="() => handleDelete(index)" class="ml-2">
                    <svg
                        class="ml-5 mt-7 w-6 h-6 cursor-pointer"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        />
                    </svg>
                </div>
            </div>

            <div>
                <error :error="errors[`${name}.${index}.currency_id`]
                    ? errors[`${name}.${index}.currency_id`][0] : null"
                />
                <error :error="errors[`${name}.${index}.amount`]
                    ? errors[`${name}.${index}.amount`][0] : null"
                />
                <error :error="errors[`${name}.${index}.without_limits`]
                    ? errors[`${name}.${index}.without_limits`][0] : null"
                />
            </div>
        </div>

        <button
            class="mt-6 text-indigo-600 hover:text-indigo-900"
            type="button"
            @click="AddItem($event)"
        >
            + Add amount
        </button>
    </div>
</template>

<script>
import siteLanguage from '../config/siteLanguage'

export default {
    name: "CurrencyAmountList",
    props: {
        value: {
            type: Array,
            default: [],
        },
        withoutLimits: {
            type: Boolean,
            default: false,
            required: false,
        },
        name: String,
        label: String,
        language: {
            type: Object,
            default: () => {
                return { id: siteLanguage.language.ENGLISH, iso: siteLanguage.iso.ENGLISH };
            },
        },
        errors: {
            type: [Object, Array],
            required: false,
        },
    },
    data() {
        return {};
    },
    methods: {
        AddItem(e) {
            e.preventDefault();
            this.value.push({
                id: null,
                amount: null,
                currency_id: null,
                without_limits: 0,
            });
        },
        withoutLimitsChanged(currencyAmount) {
            if (currencyAmount.without_limits) {
                currencyAmount.amount = null;
            } else {
                currencyAmount.without_limits = 0;
            }
        },
        handleDelete: function (indexOfItemToDelete) {
            this.value.splice(indexOfItemToDelete, 1);
        },
    },
};
</script>
